import {ADD_COMMENT_HANDLER_CURRENT_REQUEST} from "../../../enums/Request/currentRequestControls.types";

export const addCommentHandlerCurrentRequest = (value) => {
    return {
        type: ADD_COMMENT_HANDLER_CURRENT_REQUEST,
        payload: value,
    };
};
